import { useQuery } from '@tanstack/vue-query'
import type {
  QueryParamsByPath,
  ResponseByPath,
  SchemaAttributes,
  Schemas,
} from '@/api/types.js'
import { useApi } from '@/composables/useApi.js'

const SPECIES_URL = '/{provet_id}/api/species'

export type SpeciesQueryParams = QueryParamsByPath<'get', typeof SPECIES_URL>
export type SpeciesListResponse = ResponseByPath<'get', typeof SPECIES_URL>
export type Species = Schemas['Species']
export type SpeciesAttributes = SchemaAttributes<'Species'>

const speciesKeys = {
  all: ['species'] as const,
  lists: () => [...speciesKeys.all, 'list'] as const,
  list: (query: MaybeRef<SpeciesQueryParams>) =>
    [...speciesKeys.lists(), query] as const,
}

export const useSpeciesQuery = (cacheOptions?: {
  staleTime?: number
  refetchOnWindowFocus?: boolean
  refetchOnReconnect?: boolean
  refetchOnMount?: boolean
}) => {
  const api = useApi()
  const route = useRoute()

  const query = useQuery({
    queryKey: speciesKeys.all,
    queryFn: async () => {
      return api((client) =>
        client.GET(SPECIES_URL, {
          params: {
            path: { provet_id: route.params.provetId },
          },
        }),
      )
    },
    ...(cacheOptions ?? {}),
  })

  return reactive(query)
}
